@mixin device() {
    @media (max-width: 767.99px) {
        @content;
    }
}
:host {
    display: flex;
    flex-wrap: nowrap;

    padding: 1.5rem 0;
    border-bottom: 2px solid var(--gray-100);

    // cursor: pointer;

    a {
        color: inherit;
        text-decoration: none;
        &:hover {
            color: var(--primary);
            text-decoration: underline;
        }
    }

    .search-result-image {
        margin: 0;
        width: 150px;
        height: 150px;
        background-color: var(--gray-300);

        flex: 0 0 150px;

        &--provider {
            $size: 150px;
            width: $size;
            height: $size;
            flex: 0 0 $size;
        }

        @include device {
            $size: 85px;
            width: $size;
            height: $size;
            flex: 0 0 $size;
        }

        position: relative;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }
    }
    .search-result-body {
        padding-left: 1rem;
        flex-grow: 1;
        align-self: stretch;
        display: flex;
        flex-direction: column;

        .search-result-content {
            align-self: stretch;
            flex-grow: 1;
        }
    }

    .search-result-title {
        font-size: 20px;
        line-height: 28px;

        display: flex;
        position: relative;

        margin-top: 0;
        font-weight: bold;

        padding-bottom: 0;
        margin-bottom: 5px;

        > a {
            width: 100%;
            color: var(--primary);
        }

        > span, > a > span {
            width: 100%;
            display: flex;
        }

        span + span {
            margin-left: auto;
        }

        // &:after {
        //     content: '';
        //     display: block;
        //     position: absolute;
        //     top: 100%;
        //     width: 100px;
        //     border-bottom: 2px solid var(--gray-100);
        // }

        &.no-border {
            padding-bottom: 0;
            margin-bottom: 0;
            &:after {
                display: none;
            }
        }
    }
}
